<!-- src/components/yuyue/modals/LogoutModal.vue -->
<template>
    <div class="modal" :class="{ active: isVisible }">
        <div class="modal-content">
            <i class="fas fa-exclamation-triangle" style="font-size: 3rem; color: #ff9800; margin-bottom: 1rem; display: block; text-align: center;"></i>
            <h3 style="text-align: center;">确认退出登录</h3>
            <p style="text-align: center; margin-bottom: 1.5rem;">您确定要退出当前账户吗？</p>
            <div class="modal-buttons" style="display: flex; justify-content: center; gap: 15px;">
                <button class="btn btn-secondary" @click="cancelLogout">取消</button>
                <button class="btn btn-primary" @click="confirmLogout">确认退出</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LogoutModal',
        data() {
            return {
                isVisible: false
            }
        },
        methods: {
            show() {
                this.isVisible = true;
            },
            hide() {
                this.isVisible = false;
            },
            cancelLogout() {
                this.hide();
            },
            confirmLogout() {
                this.hide();
                this.$emit('logout-confirmed');
            }
        }
    }
</script>

<style scoped>
    /* Modal styles are already defined in the main component */
</style>